module.exports = __webpack_public_path__ + "img/struc-lap-length.89be9a9e.jpg";